import type { ContainerType } from "~/container";
import type { IApi } from "~/interfaces/IApi";
import type { IContactService } from "@saif-reporting/domain/interfaces/services/IContactService.js";
import type { ContactListQuery, ContactCreateRequest } from "@saif-reporting/domain/dtos/contactsDtos.js";
import type { ContactDto } from "@saif-reporting/domain/dtos/models/ContactDto.js";
import type { Paginated } from "@saif-reporting/domain/dtos/Paginated.js";

export class ContactService implements IContactService {
  private readonly baseApi: IApi;
  constructor({ baseApi }: ContainerType) {
    this.baseApi = baseApi;
  }

  async getAll(query: ContactListQuery): Promise<Paginated<ContactDto>> {
    const res = await this.baseApi.$fetch<Paginated<ContactDto>>("/contacts", { query: query });
    return res;
  }

  async getAllWithoutAccount(query: ContactListQuery): Promise<Paginated<ContactDto>> {
    const res = await this.baseApi.$fetch<Paginated<ContactDto>>("/contacts/without-account", { query: query });
    return res;
  }

  async getEmailContacts(query: ContactListQuery): Promise<Paginated<ContactDto>> {
    const res = await this.baseApi.$fetch<Paginated<ContactDto>>("/contacts/email", { query: query });
    return res;
  }

  async getWhatsappContacts(query: ContactListQuery): Promise<Paginated<ContactDto>> {
    const res = await this.baseApi.$fetch<Paginated<ContactDto>>("/contacts/whatsapp", { query: query });
    return res;
  }

  async getSmsContacts(query: ContactListQuery): Promise<Paginated<ContactDto>> {
    const res = await this.baseApi.$fetch<Paginated<ContactDto>>("/contacts/phone", { query: query });
    return res;
  }

  async view(id: number): Promise<ContactDto> {
    const res = await this.baseApi.$fetch<ContactDto>(`/contacts/${id}`);
    return res;
  }

  async create(dto: ContactCreateRequest): Promise<ContactDto> {
    const res = await this.baseApi.$fetch<ContactDto>(`/contacts`, { body: dto, method: "post" });
    return res;
  }

  async update(id: number, dto: ContactCreateRequest): Promise<ContactDto> {
    const res = await this.baseApi.$fetch<ContactDto>(`/contacts/${id}`, { body: dto, method: "patch" });
    return res;
  }

  async delete(id: number): Promise<ContactDto> {
    const res = await this.baseApi.$fetch<ContactDto>(`/contacts/${id}`, { method: "delete" });
    return res;
  }
}
